(function () {
  if (window.CmiAccessibilityWidgetInitialized) return;

  const storageKey = 'cmiAccessibilitySettings';
  const classMap = {
    contrast: 'cmi-a11y-high-contrast',
    links: 'cmi-a11y-highlight-links',
    spacing: 'cmi-a11y-spacing',
    motion: 'cmi-a11y-reduce-motion',
  };
  const textClasses = ['cmi-a11y-text-lg', 'cmi-a11y-text-xl'];
  const defaultSettings = {
    textLevel: 0,
    contrast: false,
    links: false,
    spacing: false,
    motion: false,
  };

  const widget = document.querySelector('[data-cmi-accessibility-widget]');
  if (!widget) return;

  const root = document.documentElement;
  const toggle = widget.querySelector('[data-cmi-accessibility-toggle]');
  const panel = widget.querySelector('[data-cmi-accessibility-panel]');
  const close = widget.querySelector('[data-cmi-accessibility-close]');
  const toggleControls = widget.querySelectorAll('[data-cmi-a11y-toggle]');
  const actionControls = widget.querySelectorAll('[data-cmi-a11y-action]');
  const status = widget.querySelector('[data-cmi-accessibility-status]');

  if (!toggle || !panel || !close) return;

  window.CmiAccessibilityWidgetInitialized = true;

  let settings = loadSettings();

  function loadSettings() {
    try {
      const storedSettings = JSON.parse(localStorage.getItem(storageKey));
      if (!storedSettings || typeof storedSettings !== 'object') return { ...defaultSettings };

      return {
        ...defaultSettings,
        ...storedSettings,
        textLevel: Math.min(Math.max(Number(storedSettings.textLevel) || 0, 0), textClasses.length),
      };
    } catch (error) {
      return { ...defaultSettings };
    }
  }

  function saveSettings() {
    try {
      localStorage.setItem(storageKey, JSON.stringify(settings));
    } catch (error) {
      // The current visit remains functional when browser storage is unavailable.
    }
  }

  function applySettings() {
    textClasses.forEach((className) => root.classList.remove(className));
    if (settings.textLevel > 0) {
      root.classList.add(textClasses[settings.textLevel - 1]);
    }

    Object.entries(classMap).forEach(([key, className]) => {
      root.classList.toggle(className, Boolean(settings[key]));
    });

    toggleControls.forEach((control) => {
      const key = control.dataset.cmiA11yToggle;
      control.setAttribute('aria-pressed', settings[key] ? 'true' : 'false');
    });

  }

  function announce(message) {
    if (status) status.textContent = message;
  }

  function openPanel() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
  }

  function closePanel() {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function resetSettings() {
    settings = { ...defaultSettings };
    try {
      localStorage.removeItem(storageKey);
    } catch (error) {
      // The visual reset still applies if browser storage is unavailable.
    }
    applySettings();
    announce('הגדרות הנגישות אופסו');
  }

  toggle.addEventListener('click', () => {
    if (panel.hidden) {
      openPanel();
    } else {
      closePanel();
    }
  });

  close.addEventListener('click', () => {
    closePanel();
    toggle.focus();
  });

  toggleControls.forEach((control) => {
    control.addEventListener('click', () => {
      const key = control.dataset.cmiA11yToggle;
      settings[key] = !settings[key];
      saveSettings();
      applySettings();
      announce(`${control.textContent.trim()} ${settings[key] ? 'הופעל' : 'כובה'}`);
    });
  });

  actionControls.forEach((control) => {
    control.addEventListener('click', () => {
      const action = control.dataset.cmiA11yAction;

      if (action === 'increase-text') {
        settings.textLevel = Math.min(settings.textLevel + 1, 2);
        saveSettings();
        announce(settings.textLevel === 2 ? 'גודל הטקסט הוגדל למרבי' : 'גודל הטקסט הוגדל');
      }

      if (action === 'decrease-text') {
        settings.textLevel = Math.max(settings.textLevel - 1, 0);
        saveSettings();
        announce(settings.textLevel === 0 ? 'גודל הטקסט חזר לגודל הרגיל' : 'גודל הטקסט הוקטן');
      }

      if (action === 'reset') {
        resetSettings();
        return;
      }

      applySettings();
    });
  });

  document.addEventListener('click', (event) => {
    if (!panel.hidden && !widget.contains(event.target)) {
      closePanel();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      closePanel();
      toggle.focus();
    }
  });

  applySettings();
})();
